module.exports = __webpack_public_path__ + "fonts/IRANYekanBold.60bb945.woff2";